<template>
    <select :id="id" class="form-control"></select>
</template>

<script>
import "selectize"

export default {
    name: "TagSearch",
    props: {
        value: Array,
        allowCreate: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ""
        },
        tagOptions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            id: null,
            searchbar: null,
            updateLatch: false // used to avoid infinite loops caused by selectize methods and watches
        }
    },
    watch: {
        // add new tags to option list if changed - must be list of dictionaries containing
        // text and value keys
        tagOptions(val) {
            this.searchbar.clearOptions()
            this.searchbar.addOption(val)
        },
        // if model value changes in parent, reflect change in searchbar
        value(value) {
            if (!this.updateLatch) {
                this.replaceItems(value)
            } else {
                this.updateLatch = false
            }
        }
    },
    methods: {
        // replace the selected items in the searchbar
        replaceItems(items) {
            this.searchbar.clear(true)
            if (items) {
                // create the items
                items.forEach(item => {
                    this.updateLatch = true
                    this.searchbar.createItem(item, false)
                })
            } else {
                // clear the searchbar if no items exist
                this.searchbar.clear(true, false)
            }
        },
        // create an item in the searchbar
        createItem(item) {
            this.searchbar.createItem(item)
        }
    },
    created() {
        this.id = this._uid
    },
    mounted() {
        var vm = this

        // selectize options
        let options = {
            placeholder: this.placeholder,
            maxItems: null,
            maxOptions: 10,
            highlight: false,
            persist: false,
            openOnFocus: true,
            allowEmptyOption: true,
            // delimeter: ",",
            onChange: function(value) {
                vm.$emit("input", value)
            },
            create: function(input) {
                // default format for selectize items
                return {
                    value: input,
                    text: input
                }
            }
        }

        // initialize searchbar
        let searchbar = $("#" + this.id).selectize(options)
        this.searchbar = searchbar[0].selectize
        this.searchbar.clear()

        // set initial options
        this.searchbar.addOption(this.tagOptions)

        // set initial value
        this.replaceItems(this.value)
    }
}
</script>

<style lang="scss">
@import "@/assets/styles/selectize.scss";
</style>